import ClientWebservice from './ClientWebService';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();

export default class BookingService extends ClientWebservice{
	constructor(client) {
		super();
		this.client = client
		this.auth = {
			username: this.client.login,
			password: this.client.key
		}
	}

	save(fileRequest) {
    return axios.post(`${this.url}/${fileRequest.type}s/bookings`, fileRequest, { auth:this.auth });
	}

	confirm(fileNumber) {
		return axios.put(`${this.url}/files/${fileNumber}/confirm`, null, { auth:this.auth });
	}

	getFiles() {
		return axios.get(`${this.url}/files`, { auth:this.auth });
	}
}



// WEBPACK FOOTER //
// ./src/services/BookingService.js